/* Attribute only this visit; a missing source stays unknown. No persistence. */
(() => {
  const sources = new Set(['instagram', 'tiktok', 'x', 'youtube']);
  const values = new URLSearchParams(window.location.search).getAll('utm_source');
  let source;
  if (values.length) {
    // An ambiguous or unsupported explicit source must not become a social visit.
    if (values.length !== 1 || !sources.has(values[0])) return;
    source = values[0];
  } else {
    const hosts = new Map([
      ['instagram.com', 'instagram'], ['www.instagram.com', 'instagram'],
      ['l.instagram.com', 'instagram'],
      ['tiktok.com', 'tiktok'], ['www.tiktok.com', 'tiktok'],
      ['m.tiktok.com', 'tiktok'], ['vm.tiktok.com', 'tiktok'], ['vt.tiktok.com', 'tiktok'],
      ['x.com', 'x'], ['www.x.com', 'x'], ['t.co', 'x'],
      ['twitter.com', 'x'], ['www.twitter.com', 'x'], ['mobile.twitter.com', 'x'],
      ['youtube.com', 'youtube'], ['www.youtube.com', 'youtube'],
      ['m.youtube.com', 'youtube'], ['youtu.be', 'youtube'],
    ]);
    try {
      const referrer = new URL(document.referrer);
      if (!['https:', 'http:'].includes(referrer.protocol)) return;
      source = hosts.get(referrer.hostname.toLowerCase());
    } catch (_) { return; }
    if (!source) return;
  }
  const tags = `newsletter,prelaunch,source_${source}`;
  document.querySelectorAll('form.newsletter-form input[data-mynt-newsletter-tags]')
    .forEach((input) => { input.value = tags; });
})();
